module.exports = __webpack_public_path__ + "img/shining_bliss.d1a2e888.jpg";